import * as Sentry from '@sentry/react'
import { SeverityLevel } from '@sentry/react'

const stage = import.meta.env.VITE_STAGE
const nonDebugStages: readonly string[] = ['prod']

export const isDebugStage = () => !nonDebugStages.includes(stage)

export const logMessage = (message: string, severityLevel?: SeverityLevel, label: string = 'DefaultLogger') => {
  const ts = () => new Date().toISOString() // UTC
  const prefix = `[${ts()}] [${label}]`
  const prefixedMessage = `${prefix} ${message}`
  if (severityLevel === 'fatal' || severityLevel === 'error') {
    if (isDebugStage()) console.error(prefixedMessage)
    Sentry.captureMessage(message, severityLevel)
  } else {
    if (isDebugStage()) console.log(prefixedMessage)
    Sentry.addBreadcrumb({
      message: prefixedMessage,
      level: severityLevel || 'info',
      category: label,
    })
  }
}

export const logException = (exception: unknown) => {
  if (isDebugStage()) console.error(exception)
  Sentry.captureException(exception)
}
